import '../scss/style.scss';
import '../../node_modules/swiper/css/swiper.min.css'

import newsSlider from "./components/news_slider"
import qualitySlider from "./components/quality_slider"
import servicesSlider from "./components/services_slider"
import peopleSlider from "./components/people-slider"
import cookie from "./components/cookie"
import map from "./components/map"
import sticky from './components/sticky-to-parent';
import form from './components/form';
import modal from './components/modal';
import fadeIn from './components/fadein-blocks';
import smallEvents from './components/small-events';
import homeSlider from './components/hero-slider';
import awardsSlider from './components/awards-slider';
import timeline from './components/timeline';


import $ from 'jquery';
window.jQuery = $;
window.$ = $;

$(document).ready(function () {

  newsSlider.init();
  peopleSlider.init();
  cookie.init();
  map.init();
  sticky.init();
  form.init();
  modal.init();
  smallEvents.init();
  homeSlider.init();
  awardsSlider.init();
  timeline.init();
  

  if($('.columns__list').length > 0) {
    fadeIn.scroll('.columns__list', '.columns__item', 'resize scroll');
  }

  if($('.section__quality').length > 0) {
    qualitySlider.createPagination();
    qualitySlider.changeActiveBullet();
  }

  if($('.section__services_slider').length > 0) {
    servicesSlider.init();
    servicesSlider.createPagination();
    servicesSlider.changeActiveBullet();
  }
});

const onLoad = (e) => {

  onResize(e);
  // smoothScroll.init();
}

const onResize = (e) => {

  onScroll(e);
}

const onScroll = (e) => {

  smallEvents.scrolling();
}

$(window).on('scroll', onScroll);
$(window).on('resize', onResize);
$(window).on('load', onLoad);
// $(window).on('wheel', onWheel);



